/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_No_Default_CurrencyInputs */

const en_issue_no_default_currency = /** @type {(inputs: Issue_No_Default_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`has no default currency to price in`)
};

/**
* | output |
* | --- |
* | "has no default currency to price in" |
*
* @param {Issue_No_Default_CurrencyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_no_default_currency = /** @type {((inputs?: Issue_No_Default_CurrencyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_No_Default_CurrencyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_no_default_currency(inputs)
});